import { render, staticRenderFns } from "./TableComponentMundial.vue?vue&type=template&id=1799e61c&scoped=true&"
import script from "./TableComponentMundial.vue?vue&type=script&lang=js&"
export * from "./TableComponentMundial.vue?vue&type=script&lang=js&"
import style0 from "./TableComponentMundial.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TableComponentMundial.vue?vue&type=style&index=1&id=1799e61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1799e61c",
  null
  
)

export default component.exports